export const environment = {
    apiUrl: 'https://api.aquiraplannerau.rcsworks.com/v1',
    appVersion: '0.0.0',
    production: 'true',
    baseHref: '.',
    redirectUri: window.location.origin + '/login/callback',
    rcsCdnUrl: 'https://cdn.rcsworks.com',
    securityApiUrl: 'https://api.ap.security.rcsworks.com/v1'
   };